import {ConfigMigrationAnalyticsAction} from 'constants/AnalyticsConstants';

import {MigrationStep, PlanningCategory} from '../types/MigrationStep';
import {
  BaseConfigMigrationEventMetadata,
  CompletedTimedConfigMigrationEventMetadata,
  trackConfigMigrationEvent,
} from './CommonConfigMigrationAnalytics';

// Metadata
interface SharedValidatePlanEventMetadata {
  /** The active planning tab when the user clicked the validate button */
  step: MigrationStep;
  active_planning_tab: PlanningCategory;
  total_error_count?: number;
  object_type_to_error_count?: Record<string, number>;
}

export type InitiatedValidatePlanEventMetadata = SharedValidatePlanEventMetadata &
  BaseConfigMigrationEventMetadata;
export type CompletedValidatePlanEventMetadata = SharedValidatePlanEventMetadata &
  CompletedTimedConfigMigrationEventMetadata;

/**
 * Track when a user initiates validation in the new tabs UI.
 * Unlike the legacy per-step validation, this validates all objects at once.
 */
export function trackInitiatedValidatePlan(metadata: InitiatedValidatePlanEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.INITIATED_VALIDATE_CONFIG_TABS, metadata);
}

/**
 * Track when validation completes in the new tabs UI.
 * Includes timing information and error counts.
 */
export function trackCompletedValidatePlan(metadata: CompletedValidatePlanEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.COMPLETED_VALIDATE_CONFIG_TABS, metadata);
}
